import { userConstants } from '../_constants';
import { getApiErrorMessage, userService } from '../_services';
import { alertActions } from './alert.actions';
import { history } from '../_helpers/history';
import { setSession } from '../_helpers/session';
import { ErrorMessage } from '../_helpers/ErrorMessage';
import { authenticationActions } from '../_slices/authentication.slice';

export const userActions = {
  login,
  recoverPassword,
  recover,

  logout,
  register,
  getAll,
  delete: _delete,

  CandidateProfile,
  CandidateScholarship,
  CandidateLanguages,
  CandidateJobs,
  CandidateJobProfile,
  CandidateExpectedJobs,
  CandidateJobProfileAll,
};

function CandidateJobProfileAll() {
  return async (dispatch) => {
    dispatch({
      type: userConstants.IS_LOADING2,
      payload: true,
    });

    const response2 = await userService.CandidateJobProfile();

    dispatch({
      type: userConstants.SET_CANDIDATE_JOB_PROFILE,
      payload: response2.data,
    });

    const response3 = await userService.CandidateExpectedJobs();

    dispatch({
      type: userConstants.SET_EXPECTED_JOBS,
      payload: response3.data,
    });

    const response = await userService.CandidateJobs();

    dispatch({
      type: userConstants.SET_CANDIDATE_JOBS,
      payload: response.data.results,
    });

    dispatch({
      type: userConstants.IS_LOADING2,
      payload: false,
    });
  };
}

function CandidateProfile() {
  return async (dispatch) => {
    dispatch({
      type: userConstants.IS_LOADING,
      payload: true,
    });
    const response = await userService.CandidateProfile();

    dispatch({
      type: userConstants.SET_PROFILE,
      payload: response.data,
    });

    dispatch({
      type: userConstants.IS_LOADING,
      payload: false,
    });
  };
}

function CandidateScholarship() {
  return async (dispatch) => {
    dispatch({
      type: userConstants.IS_LOADING_CANDIDATE_SCHOOLS,
      payload: true,
    });
    const response = await userService.CandidateScholarship();

    dispatch({
      type: userConstants.SET_CANDIDATE_SCHOOLS,
      payload: response.data.results,
    });
    dispatch({
      type: userConstants.IS_LOADING_CANDIDATE_SCHOOLS,
      payload: false,
    });
  };
}
function CandidateLanguages() {
  return async (dispatch) => {
    dispatch({
      type: userConstants.IS_LOADING_CANDIDATE_LANGS,
      payload: true,
    });
    const response = await userService.CandidateLanguages();

    dispatch({
      type: userConstants.SET_CANDIDATE_LANGUAGES,
      payload: response.data.results,
    });
    dispatch({
      type: userConstants.IS_LOADING_CANDIDATE_LANGS,
      payload: false,
    });
  };
}
function CandidateJobs() {
  return async (dispatch) => {
    const response = await userService.CandidateJobs();

    dispatch({
      type: userConstants.SET_CANDIDATE_JOBS,
      payload: response.data.results,
    });
  };
}

function CandidateJobProfile() {
  return async (dispatch) => {
    const response = await userService.CandidateJobProfile();

    dispatch({
      type: userConstants.SET_CANDIDATE_JOB_PROFILE,
      payload: response.data,
    });
  };
}

function CandidateExpectedJobs() {
  return async (dispatch) => {
    const response = await userService.CandidateExpectedJobs();

    dispatch({
      type: userConstants.SET_EXPECTED_JOBS,
      payload: response.data,
    });
  };
}

function login(username, toast) {
  return (dispatch) => {
    dispatch(request({ username }));
    dispatch(authenticationActions.setLoading(true));

    userService
      .login(username)
      .then(
        (response) => {
          const data = response.data;
          setSession({
            token: data.access,
            userType: data.user_type,
          });

          dispatch(authenticationActions.success(data.user_type));
          history.push('/applicants');
        },
        (error) => {
          const errorMessage = getApiErrorMessage(error);
          dispatch(failure(errorMessage));
          dispatch(alertActions.error(errorMessage));

          const msg = ErrorMessage(error);
          toast.error(msg, {
            type: 'error',
          });
        }
      )
      .finally(() => {
        dispatch(authenticationActions.setLoading(false));
      });
  };

  function request(user) {
    return authenticationActions.request(user);
  }
  function failure(error) {
    return authenticationActions.failure(error);
  }
}

function logout() {
  return (dispatch) => {
    dispatch(authenticationActions.logout());
    dispatch({ type: userConstants.LOGOUT });
    userService.logout();
    history.push('/login');
  };
}

function register(user) {
  return (dispatch) => {
    dispatch(request(user));

    userService
      .register(user)
      .then(() => {
        dispatch(success());
        // history.push('/login');
        dispatch(alertActions.success('Registration successful'));
      })
      .catch((error) => {
        const errorMsg = error.toString();
        if (errorMsg === 'Error: Network Error') {
          const msg = 'Intenta más tarde';
          dispatch(failure(msg));
          dispatch(alertActions.error(msg));
        } else {
          const errorData = error.response.data;
          const keys = Object.keys(errorData);
          let errorMsg = '';
          keys.forEach((el) => {
            errorData[el].forEach((msg) => {
              errorMsg = msg;
            });
          });
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(errorMsg));
        }
      });
  };

  function request(user) {
    return { type: userConstants.REGISTER_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.REGISTER_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.REGISTER_FAILURE, error };
  }
}

function getAll() {
  return (dispatch) => {
    dispatch(request());

    userService.getAll().then(
      (users) => dispatch(success(users)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: userConstants.GETALL_REQUEST };
  }
  function success(users) {
    return { type: userConstants.GETALL_SUCCESS, users };
  }
  function failure(error) {
    return { type: userConstants.GETALL_FAILURE, error };
  }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  return (dispatch) => {
    dispatch(request(id));

    userService.delete(id).then(
      () => dispatch(success(id)),
      (error) => dispatch(failure(id, error.toString()))
    );
  };

  function request(id) {
    return { type: userConstants.DELETE_REQUEST, id };
  }
  function success(id) {
    return { type: userConstants.DELETE_SUCCESS, id };
  }
  function failure(id, error) {
    return { type: userConstants.DELETE_FAILURE, id, error };
  }
}

function recoverPassword(data) {
  return async (dispatch) => {
    await userService.recoverPassword(data);

    dispatch({
      type: userConstants.UPDATE_SUCCESS_RECOVER_PASSWORD,
      payload: true,
    });
  };
}
function recover(data) {
  return async (dispatch) => {
    await userService.recover(data);

    dispatch({
      type: userConstants.UPDATE_SUCCESS_RECOVER,
      payload: true,
    });
  };
}
